import { gql, useQuery } from '@apollo/client'

const DIMENSION_LIST_QUERY = gql`
  query {
    dimensionList {
      id
      name
      weight
    }
  }
`

export function useDimensionListQuery() {
  const { data, ...rest } = useQuery(DIMENSION_LIST_QUERY)

  return {
    data: data?.dimensionList,
    ...rest
  }
}
